var map = {
	"./Barcelona_1-0243.jpg": 37,
	"./Barcelona_1-DSC_0109.jpg": 38,
	"./Barcelona_1-DSC_0117.jpg": 39,
	"./Barcelona_1-DSC_0123.jpg": 40,
	"./Barcelona_1-DSC_0129.jpg": 41,
	"./Barcelona_1-DSC_0150.jpg": 42,
	"./Barcelona_1-DSC_0232.jpg": 43,
	"./Barcelona_1-DSC_0277.jpg": 44,
	"./China1.jpg": 45,
	"./China12.jpg": 46,
	"./China21.jpg": 47,
	"./China24.jpg": 48,
	"./China25-v2.jpg": 49,
	"./Coast10.jpg": 50,
	"./Coast12.jpg": 51,
	"./Coast4.jpg": 52,
	"./Image1-v2.jpg": 53,
	"./Image1.jpg": 54,
	"./Warriors3.jpg": 55,
	"./chinese-cyclists-mobile.jpg": 56,
	"./chinese-cyclists.jpg": 57,
	"./coast8-mobile.jpg": 58,
	"./coast8.jpg": 59,
	"./cornwall1-mobile.jpg": 60,
	"./cornwall1.jpg": 61,
	"./cornwall2.jpg": 62,
	"./cornwall3-mobile.jpg": 63,
	"./cornwall3.jpg": 64,
	"./whitby-mobile.jpg": 65,
	"./whitby.jpg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;